import './Form.css'
import {useState, useEffect} from "react";
import {languageManager} from "../../utils/i18n";
import main_gif from "../../assets/images/black_figures.gif"

export const Form = ({id = null, canSubmit, setCanSubmit, event = null, className}) => {
	const [t] = useState(() => key => languageManager.t(key));
	const lang = languageManager.getCurrentLanguage();
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		message: '',
	});
	const [errors, setErrors] = useState({});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [submitStatus, setSubmitStatus] = useState(null);
	const [, setIsMount] = useState(false)
	const [isLoad, setIsLoad] = useState(false)

	const form = event?.form

	useEffect(() => {
		setIsLoad(true)
		if (form?.limit) {
			fetch(form?.limit_script)
				.then(res => res.json())
				.then(data => {
					if (data.filledRows > form?.limit) {
						setCanSubmit(false);
					}
				})
				.catch(error => {
					console.error('Error fetching filled rows:', error);
				})
				.finally(() => {
					setIsLoad(false)
				});
		} else {
			setIsLoad(false)
		}
	}, [event]);

	useEffect(() => {
		setIsMount(true)
	}, []);

	// Функція для перевірки наявності * у value
	const hasAsterisk = (value) => {
		return value && value.includes('*');
	};

	// Текст підтвердження беремо з колонки «Відповідь» таблиці, а якщо вона порожня —
	// дефолтний. Порожня клітинка інколи містить лише невидимий символ, тому чистимо.
	const getSuccessMessage = () => {
		const response = String(event?.[lang]?.form_response ?? form?.response ?? '')
			.replace(/[\u200B-\u200D\uFEFF]/g, '')
			.trim();

		return response || t('main.form.response');
	};

	// Дата в таблиці лежить як "вівторок, 26 серпня 2025 р." — у картці показуємо
	// коротко й одним рядком разом з часом, як було в старому форматі
	const getEventDate = () => {
		const rawDate = (event?.[lang]?.date || '').replace(/[\u00A0\u202F]/g, ' ').trim();
		const weekday = /^(понеділок|вівторок|середа|четвер|п['ʼ’]ятниця|субота|неділя|monday|tuesday|wednesday|thursday|friday|saturday|sunday)\s*,\s*/i;
		const date = rawDate.replace(weekday, '').replace(/\s*р\.?$/i, '').trim();

		return [date, (event?.time || '').trim()].filter(Boolean).join(', ');
	};

	// Зірочку обов'язковості показуємо окремо й червоним, а не як частину тексту label
	const renderLabel = (text) => {
		const label = String(text ?? '').replace(/\s*\*+\s*$/, '');

		if (!hasAsterisk(text)) {
			return label;
		}

		return <>{label}<span style={{color: 'red'}}> *</span></>;
	};

	// Визначає, що саме треба перевіряти у другому інпуті, за його label.
	// Беремо саме той текст, який бачить користувач (як у розмітці нижче).
	const getSecondFieldType = () => {
		if (id === null) {
			return 'email';
		}

		// Новий формат (Google-таблиця) тримає label у event[lang].form_phone,
		// старий (events в i18n) — у form.email / form.surname
		const label = ((event?.[lang]?.form_phone !== '' && event?.[lang]?.form_phone)
			|| form?.email
			|| form?.surname
			|| t('main.form.surname')).toLocaleLowerCase();

		const hasEmail = /e-?mail|пошт/.test(label);
		const hasPhone = /телефон|phone|тел\.|моб/.test(label);

		if (hasEmail && hasPhone) {
			return 'email_or_phone';
		}
		if (hasEmail) {
			return 'email';
		}
		if (hasPhone) {
			return 'phone';
		}

		return 'text';
	};

	const isValidEmail = (value) => /^\S+@\S+\.\S+$/.test(value);

	const isValidPhone = (value) => {
		if (!/^\+?[\d\s()-]+$/.test(value)) {
			return false;
		}

		const digits = value.replace(/\D/g, '');

		return digits.length >= 9 && digits.length <= 15;
	};

	const validate = () => {
		const newErrors = {};

		// Перевірка поля name тільки якщо воно обов'язкове
		const isNameRequired = form?.required?.name || (id === null) || hasAsterisk(event[lang]?.form_name);
		if (isNameRequired && !formData.name.trim()) {
			newErrors.name = "Введіть ім'я";
		} else if (isNameRequired && form?.surname !== '') {
			const nameParts = formData.name.trim().split(/\s+/);
			console.log(nameParts)

			if (nameParts.length < 2 && event.uk?.form_name.toLocaleLowerCase().includes('імʼя, прізвище')) {
				newErrors.name = "Введіть ім'я та прізвище";
			} else {
				const invalidPart = nameParts.find(part => part.length < 3);
				if (invalidPart) {
					newErrors.name = "Ім'я та прізвище повинні містити мінімум по 3 літери кожне";
				}
			}
		}

		// Другий інпут залежно від label може бути email, телефоном або прізвищем
		const secondFieldType = getSecondFieldType();
		const secondFieldValue = formData.email.trim();

		// Перевірка другого поля тільки якщо воно обов'язкове
		const isEmailRequired = form?.required?.surname || form?.required?.email || (id === null) || hasAsterisk(event[lang]?.form_phone);

		if (isEmailRequired && !secondFieldValue) {
			if (secondFieldType === 'email') {
				newErrors.email = "Введіть email";
			} else if (secondFieldType === 'phone') {
				newErrors.email = "Введіть номер телефону";
			} else if (secondFieldType === 'email_or_phone') {
				newErrors.email = "Введіть email або номер телефону";
			} else {
				newErrors.email = id ? "Введіть прізвище" : "Введіть email";
			}
		} else if (secondFieldValue) {
			if (secondFieldType === 'email' && !isValidEmail(secondFieldValue)) {
				newErrors.email = "Некоректний email";
			} else if (secondFieldType === 'phone' && !isValidPhone(secondFieldValue)) {
				newErrors.email = "Некоректний номер телефону";
			} else if (secondFieldType === 'email_or_phone' && !isValidEmail(secondFieldValue) && !isValidPhone(secondFieldValue)) {
				newErrors.email = "Некоректний email або номер телефону";
			}
		}

		// Перевірка поля message тільки якщо воно обов'язкове
		const isMessageRequired = form?.required?.message || (event && hasAsterisk(event[lang]?.form_comment));
		if (isMessageRequired && !formData.message.trim()) {
			newErrors.message = "Заповніть це поле";
		}

		return newErrors;
	};

	const sendEmail = async (data) => {
		const response = await fetch('https://api.kudriavka.com/api/send-email', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		});

		if (!response.ok) {
			const errorData = await response.json();
			throw new Error(errorData.message || 'Помилка відправки');
		}

		return await response.json();
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setSubmitStatus(null);

		const validationErrors = validate();
		if (Object.keys(validationErrors).length > 0) {
			setErrors(validationErrors);
			return;
		}

		setErrors({});
		setIsSubmitting(true);

		try {
			if (id === null) {
				const result = await sendEmail(formData);
				console.log('Email sent successfully:', result);
				setSubmitStatus('success');
				setFormData({ name: '', email: '', message: '' });
				setTimeout(() => {
					setSubmitStatus(null);
				}, 5000);
			} else {
				if (!event.form) {
					throw new Error('Invalid form ID');
				}

				if (event.limit !== '' && !canSubmit) {
					throw new Error('Ліміт записів вичерпано');
				}

				const url = new URL(event.form)

				// Google Forms приймає відповіді лише на /formResponse.
				// POST на /viewform повертає 405 Method Not Allowed.
				const actionUrl = `${url.origin}${url.pathname.replace(/\/(viewform|formResponse)\/?$/, '/formResponse')}`;

				const fieldIds = {};
				const entryKeys = [];
				const params = url.searchParams;

				for (const [key, value] of params.entries()) {
					if (!key.startsWith('entry.')) {
						continue;
					}

					const fieldId = key; // зберігаємо повний ключ "entry.146328755"
					entryKeys.push(fieldId);

					// Визначаємо, яке поле це (за значенням або позицією)
					if (value === '1' || key === 'entry.146328755') {
						fieldIds.name = fieldId;
					} else if (value === '2' || key === 'entry.170292197') {
						fieldIds.surname = fieldId;
					} else if (value === '3' || key === 'entry.1521269411') {
						fieldIds.message = fieldId;
					}
				}

				// Якщо в префіл-посиланні немає маркерів 1/2/3 — беремо поля за порядком
				fieldIds.name = fieldIds.name || entryKeys[0];
				fieldIds.surname = fieldIds.surname || entryKeys[1];
				fieldIds.message = fieldIds.message || entryKeys[2];

				if (!fieldIds.name) {
					throw new Error('Invalid form ID');
				}

				const gFormData = new URLSearchParams();
				gFormData.append(fieldIds.name, formData.name || '');
				if (fieldIds.surname) {
					gFormData.append(fieldIds.surname, formData.email || '');
				}
				if (fieldIds.message) {
					gFormData.append(fieldIds.message, formData.message || '');
				}

				await fetch(actionUrl, {
					method: 'POST',
					mode: 'no-cors',
					body: gFormData,
				});

				setSubmitStatus('success');
				setFormData({ name: '', email: '', message: '' });

				setTimeout(() => {
					setSubmitStatus(null);
				}, 5000);
			}
		} catch (error) {
			console.error('Error sending form:', error);
			setSubmitStatus('error');

			// eslint-disable-next-line no-mixed-operators
			if (id === null && error.message.includes('validation') || error.message.includes('валідації')) {
				try {
					const errorData = JSON.parse(error.message);
					if (errorData.errors) {
						setErrors(errorData.errors);
					}
				} catch (parseError) {
				}
			}

			setTimeout(() => {
				setSubmitStatus(null);
			}, 5000);
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});

		if (errors[e.target.name]) {
			setErrors({
				...errors,
				[e.target.name]: ''
			});
		}
	};

	const getSubmitButtonText = () => {
		if (isSubmitting) {
			return `${t('main.form.button.sending')}...`;
		}
		if (submitStatus === 'success') {
			return `${t('main.form.button.sent')}...`;
		}

		return event ? t('event.button') : t('main.form.button')
		// return t('main.form.button');
	};

	const getSubmitButtonClass = () => {
		let baseClass = 'form-item';
		if (isSubmitting) {
			baseClass += ' submitting';
		}
		if (submitStatus === 'success') {
			baseClass += ' success';
		}
		if (submitStatus === 'error') {
			baseClass += ' error';
		}
		return baseClass;
	};

	if (isLoad) {
		return <img src={main_gif} alt="Slider Main" className="event_loader" />
	}

	return (
		<form className={`main_element main_element__border form ${className}`} onSubmit={handleSubmit} noValidate>
			<h2 className='form_header form-item'>{t('event.title')}</h2>

			{event && (
				<>
					{event[lang]?.form_title && <h3 className='form_subtitle form-item'>{event[lang].form_title}</h3>}
					{event[lang]?.form_subtitle && <p className='form_speaker form-item'>{event[lang].form_subtitle}</p>}
					{getEventDate() && <p className='form_date form-item'>{getEventDate()}</p>}
					{event[lang]?.form_address && <p className='form_address form-item'>{event[lang].form_address}</p>}
					{event[lang]?.description && (
						<div className='form_description form-item'>
							{event[lang].description
								.split(/\r?\n/)
								.filter(line => line.trim() !== '')
								.map((line, i) => (
									<p key={i}>{line}</p>
								))}
						</div>
					)}
				</>
			)}

			{submitStatus === 'success' && (
				<div className="form-status form-status--success">
					{getSuccessMessage()}
				</div>
			)}

			{submitStatus === 'error' && (
				<div className="form-status form-status--error">
					{t('main.form.error')}
				</div>
			)}

			{form?.limit && !canSubmit && (
				<div className="form-status form-status--error">
					{t('main.form.limit')}
				</div>
			)}

			<div className="form-item">
				<label htmlFor="name">
					{(event && event[lang]?.form_name !== '') ? renderLabel(event[lang]?.form_name) : t('main.form.name')}
					{/*{(form?.required?.name || id === null) && <span style={{color: 'red'}}> *</span>}*/}
				</label>
				<input
					type="text"
					id="name"
					name="name"
					value={formData.name}
					onChange={handleChange}
					disabled={isSubmitting || (form?.limit && !canSubmit)}
					required={form?.required?.name || id === null || (event && hasAsterisk(event[lang]?.form_name))}
				/>
				{errors.name && <div className="form-error">{errors.name}</div>}
			</div>

			<div className="form-item">
				{event ? <>
						<label htmlFor="email">
							{(event && event[lang]?.form_phone !== '') ? renderLabel(event[lang]?.form_phone) :  t('main.form.surname')}
							{/*{(form?.required?.surname || form?.required?.email) && <span style={{color: 'red'}}> *</span>}*/}
						</label>
						<input
							type="text"
							id="email"
							name="email"
							value={formData.email}
							onChange={handleChange}
							disabled={isSubmitting || (form?.limit && !canSubmit)}
							required={form?.required?.surname || form?.required?.email || (event && hasAsterisk(event[lang]?.form_phone))}
						/>
						{errors.email && <div className="form-error">{errors.email}</div>}
					</> :
					<>
						<label htmlFor="email">
							{t('main.form.mail')}
							<span style={{color: 'red'}}> *</span>
						</label>
						<input
							type="email"
							id="email"
							name="email"
							value={formData.email}
							onChange={handleChange}
							disabled={isSubmitting}
							required={true}
						/>
						{errors.email && <div className="form-error">{errors.email}</div>}</>}
			</div>

			<div className="form-message form-item">
				<label htmlFor="message">
					{(event && event[lang]?.form_comment !== '') ? renderLabel(event[lang]?.form_comment) :  t('main.form.message')}

					{/*{(event && event.disclaimer !== '') ? event?.disclaimer : t('main.form.message')}*/}
					{/*{form?.required?.message && <span style={{color: 'red'}}> *</span>}*/}
				</label>
				<textarea
					id="message"
					name="message"
					rows="5"
					value={formData.message}
					onChange={handleChange}
					disabled={isSubmitting || (form?.limit && !canSubmit)}
					required={form?.required?.message || (event && hasAsterisk(event[lang]?.form_comment))}
				/>
				{errors.message && <div className="form-error">{errors.message}</div>}
			</div>

			<button
				type="submit"
				className={getSubmitButtonClass()}
				disabled={isSubmitting || (form?.limit && !canSubmit)}
			>
				{getSubmitButtonText()}
			</button>

			<span className='form_span'>{t("main.address")}</span>
		</form>
	);
};